import { COMPANY_STATUS, CompanyProfile } from '@api/models/companyApi.models';
import { useEffect, useState } from 'react';
import { CompanyApi } from '@api/Company.api';

type FetchCompanyProfile = {
  companyPublicProfile: CompanyProfile | null;
  profileComplete: boolean;
  loading: boolean;
  loaded: true | null;
};

/**
 * Fetch CompanyProfile from CompanyApi.getCompanyPublicById()
 *
 * @param {number} id companyId
 * @returns `{ companyProfile: CompanyProfile; profileComplete: boolean; loading: boolean; }`
 */
export const useFetchCompanyProfilePublic = (
  companyId?: number | null
): FetchCompanyProfile => {
  const [companyPublicProfile, setCompanyPublicProfile] =
    useState<CompanyProfile | null>(null);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState<true | null>(null);

  useEffect(() => {
    if (companyId) {
      const fetchProfile = async (): Promise<void> => {
        try {
          setLoading(true);
          const res = await CompanyApi.getCompanyPublicById(companyId);
          setCompanyPublicProfile(res.data);
        } catch (error: any) {
          console.error(
            'Error for useFetchCompanyProfile -> CompanyApi.getById()',
            error
          );
        } finally {
          setLoading(false);
          setLoaded(true);
        }
      };

      fetchProfile();
    } else {
      setLoaded(true);
    }
  }, [companyId]);

  const profileComplete =
    companyPublicProfile?.status === COMPANY_STATUS.COMPLETED;

  return { companyPublicProfile, profileComplete, loading, loaded };
};
